/* 🤖 this file was generated by svg-to-ts*/
export const icoVuejs: {
  name: 'vuejs';
  data: string;
} = {
  name: 'vuejs',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 12.794L17.587 3h-3.273L12 7.153v.002L9.69 3H6.412L12 12.794z" fill="#909090"/><path d="M18.456 3.004L12 14.32 5.544 3.004H2L12 21 22 3.004h-3.544z" fill="#909090"/></svg>`
};
